module.exports = __webpack_public_path__ + "img/CUBIC_RENDER7.3e47bc9c.png";